import EditPanelMixin from './EditPanelMixin';

export default {
    name: 'EditPanelSkeleton',
    mixins: [EditPanelMixin],
    props: {
        scrollTarget: {
            type: Function,
            default: () => null
        }
    },
    computed: {
        IsDetailUserForm() {
            return this.CurUserForm.Type === 'DetailUserForm';
        }
    },
    render(h) {
        const body = this.$slots.default;

        let _footer = this.$slots.footer;

        if (!_footer) {
            // 保存按钮
            const _saveButton =
                this.CurUserForm.CurViewState !==
                this.CurUserForm.Cfg.ViewState.View ? (
                    <a-button icon="save" onClick={this.OnSaveClick}>
                        保存
                    </a-button>
                ) : null;

            _footer = (
                <div class="cg-edit-footer">
                    <div class="cg-edit-footer-left">
                        <slot name="footer-left"></slot>
                    </div>
                    <div class="cg-edit-footer-right">
                        <slot name="footer-right">
                            {_saveButton}
                            <a-button onClick={this.OnCancelClick}>
                                返回
                            </a-button>
                        </slot>
                    </div>
                </div>
            );
        }

        return this.$root.constructor.qiankunProps?.needCard === false ? (
            body
        ) : (
            <div class="cg-userform-edit-warp">
                <a-card class="cmn-control-container">
                    <template slot="title">
                        <a-icon type="appstore" />
                        {this.EditPanelTitle}
                    </template>
                    <template slot="extra">{this.$scopedSlots.extra?.()}</template>

                    {body}

                    {this.IsDetailUserForm ? null : (
                        <a-affix
                            v-show={!this.IsCustomLayoutMode}
                            offset-bottom={0}
                            target={this.scrollTarget}
                        >
                            {_footer}
                        </a-affix>
                    )}
                </a-card>
            </div>
        );
    }
};
